export default __webpack_public_path__ + "static/media/gril.0398ee4e.png";